/**
 * Countries Module
 */
import Vue from 'vue';
import router from '../../../router/router';
import { apiModel, makeApiRequest } from "../../../api";

// States
const state = {
    regions: []
};

// Getters
const getters = {
    regions: state => {
        return state.regions
    }
};

// Actions
const actions = {
    getRegions(context, payload) {
        function successCallback(response) {
            context.commit('getRegionsHandler', { regions: response.data.dictionnaires });
        }

        function errorCallback(error) {
            Vue.swal(
                payload.errorMessages.error,
                '',
                'error'
            );
        }

        const localToken = localStorage.getItem('ms-token');

        makeApiRequest(payload.args, apiModel.Region.List, localToken, successCallback, errorCallback, payload.errorMessages);
    }
};

// Mutations
const mutations = {
    getRegionsHandler(state, { regions }) {
        state.regions = regions;
    }
};

export default {
    state,
    getters,
    actions,
    mutations
}